import React from 'react';
import { usePageContent } from '../hooks/usePageContent';
import { useButtonLinks } from '../hooks/useButtonLinks';
import { useTranslation } from '../hooks/useTranslation';

const Services = () => {
  const { handleButtonClick } = useButtonLinks();
  const { t, language } = useTranslation();
  const defaultContent = {
    servicesTitle: 'Get Industry-Leading Prices',
    servicesSubtitle: 'Find spreads as low as 0.0 pips for Forex and stock trading using our powerful platforms.',
    forexTitle: 'Forex',
    forexPriceLabel: 'Spread as low as',
    forexPriceValue: '0.0 pip',
    forexDescription: 'Trade 200+ Forex spot pairs and 200+ futures across majors and minors with a handful of instruments.',
    indicesTitle: 'Indices',
    indicesPriceLabel: 'Commission as low as',
    indicesPriceValue: '0 $',
    indicesDescription: 'Trade on the world\'s largest stock marketplaces using the most powerful tools available.',
    sharesTitle: 'Shares',
    sharesPriceLabel: 'Commission as low as',
    sharesPriceValue: '0 $',
    sharesDescription: 'Enjoy leveraged commission-free on trading. Get access to 1000+ CFD stocks. Go long or short easily.',
    commoditiesTitle: 'Commodities',
    commoditiesPriceLabel: 'Spread as low as',
    commoditiesPriceValue: '0.004 pip',
    commoditiesDescription: 'Get ahead by trading on energy and metals. Drive the global economy.',
    servicesCtaText: 'Start your financial trading journey now.',
    servicesCtaButton: 'Create Account'
  };
  
  const homeContent = usePageContent('home', defaultContent);
  
  // Helper function to get content with translation priority
  const getContent = (adminContent, translationKey, fallback) => {
    if (language === 'ar') {
      // For Arabic, always use translations first, completely bypassing admin content
      const translation = t(translationKey);
      return translation && translation !== translationKey ? translation : fallback;
    }
    return adminContent || t(translationKey) || fallback;
  };

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2>{getContent(homeContent.servicesTitle, 'services.title', 'Get Industry-Leading Prices')}</h2>
          <p>{getContent(homeContent.servicesSubtitle, 'services.subtitle', 'Find spreads as low as 0.0 pips for Forex and stock trading using our powerful platforms.')}</p>
        </div>
        
        <div className="services-grid">
          <div className="service-card forex-card">
            <div className="service-content">
              <h3 className="service-title">{getContent(homeContent.forexTitle, 'services.forex.title', 'Forex')}</h3>
              <div className="service-price">
                <span className="price-label">{getContent(homeContent.forexPriceLabel, 'services.forex.priceLabel', 'Spread as low as')}</span>
                <span className="price-value">{getContent(homeContent.forexPriceValue, 'services.forex.priceValue', '0.0 pip')}</span>
              </div>
              <p className="service-description">
                {getContent(homeContent.forexDescription, 'services.forex.description', 'Trade 200+ Forex spot pairs and 200+ futures across majors and minors with a handful of instruments.')}
              </p>
            </div>
          </div>
          
          <div className="service-card indices-card">
            <div className="service-content">
              <h3 className="service-title">{getContent(homeContent.indicesTitle, 'services.indices.title', 'Indices')}</h3>
              <div className="service-price">
                <span className="price-label">{getContent(homeContent.indicesPriceLabel, 'services.indices.priceLabel', 'Commission as low as')}</span>
                <span className="price-value">{getContent(homeContent.indicesPriceValue, 'services.indices.priceValue', '$0')}</span>
              </div>
              <p className="service-description">
                {getContent(homeContent.indicesDescription, 'services.indices.description', 'Trade on the world\'s largest stock marketplaces using the most powerful tools available.')}
              </p>
            </div>
          </div>
          
          <div className="service-card shares-card">
            <div className="service-content">
              <h3 className="service-title">{getContent(homeContent.sharesTitle, 'services.shares.title', 'Shares')}</h3>
              <div className="service-price">
                <span className="price-label">{getContent(homeContent.sharesPriceLabel, 'services.shares.priceLabel', 'Commission as low as')}</span>
                <span className="price-value">{getContent(homeContent.sharesPriceValue, 'services.shares.priceValue', '$0')}</span>
              </div>
              <p className="service-description">
                {getContent(homeContent.sharesDescription, 'services.shares.description', 'Enjoy leveraged commission-free on trading. Get access to 1000+ CFD stocks. Go long or short easily.')}
              </p>
            </div>
          </div>
          
          <div className="service-card commodities-card">
            <div className="service-content">
              <h3 className="service-title">{getContent(homeContent.commoditiesTitle, 'services.commodities.title', 'Commodities')}</h3>
              <div className="service-price">
                <span className="price-label">{getContent(homeContent.commoditiesPriceLabel, 'services.commodities.priceLabel', 'Spread as low as')}</span>
                <span className="price-value">{getContent(homeContent.commoditiesPriceValue, 'services.commodities.priceValue', '0.004 pip')}</span>
              </div>
              <p className="service-description">
                {getContent(homeContent.commoditiesDescription, 'services.commodities.description', 'Get ahead by trading on energy and metals. Drive the global economy.')}
              </p>
            </div>
          </div>
        </div>
        
        <div className="services-cta">
          <p>{getContent(homeContent.servicesCtaText, 'services.ctaText', 'Start your financial trading journey now')}</p>
          <button 
            className="btn btn-primary"
            onClick={(e) => handleButtonClick('openAccount', e)}
          >
            {getContent(homeContent.servicesCtaButton, 'services.ctaButton', 'Create Account')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;